import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import SocialDashboard from './SocialDashboard';

const Dashboard = ({ isOpen, onClose, onShowMap }) => {
  const { user } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    const handleEscapeKey = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    window.addEventListener('resize', handleResize);
    document.addEventListener('keydown', handleEscapeKey);

    // Don't disable body scroll for dashboard - it needs to scroll
    // The dashboard is the main content view, not a modal overlay

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isOpen, onClose]);

  // Generate mock stats based on user data
  const generateStats = () => {
    const joinedDate = new Date(user?.createdAt || '2023-01-01');
    const daysSinceJoined = Math.floor((new Date() - joinedDate) / (1000 * 60 * 60 * 24));
    
    return {
      reviewsWritten: Math.min(Math.floor(daysSinceJoined / 7) + Math.floor(Math.random() * 20), 50),
      placesVisited: Math.min(Math.floor(daysSinceJoined / 30) + Math.floor(Math.random() * 10), 25),
      safetyScore: 75 + Math.floor(Math.random() * 20),
      communityImpact: Math.floor(daysSinceJoined / 3) + Math.floor(Math.random() * 50)
    };
  };

  // Generate mock activities
  const generateActivities = () => {
    const activities = [
      {
        id: '1',
        type: 'review',
        title: 'Added safety review for local restaurant',
        location: user?.profile?.location?.city || 'Current Location',
        timestamp: '2 hours ago',
        rating: 5,
        safetyLevel: 'safe'
      },
      {
        id: '2',
        type: 'alert',
        title: 'Safety alert: Construction area ahead',
        location: user?.profile?.location?.city || 'Current Location',
        timestamp: '4 hours ago',
        safetyLevel: 'caution'
      },
      {
        id: '3',
        type: 'interaction',
        title: 'Your review received 8 helpful votes',
        location: 'Downtown Area',
        timestamp: '1 day ago',
        rating: 4
      },
      {
        id: '4',
        type: 'checkin',
        title: 'Checked in at popular tourist spot',
        location: user?.profile?.location?.city || 'Current Location',
        timestamp: '2 days ago',
        safetyLevel: 'safe'
      },
      {
        id: '5',
        type: 'review',
        title: 'Updated safety info for shopping district',
        location: 'Shopping District',
        timestamp: '3 days ago',
        rating: 4,
        safetyLevel: 'caution'
      }
    ];

    return activities;
  };

  const handleAction = (action, data) => {
    console.log('Dashboard action:', action, data);
    switch (action) {
      case 'add-review':
        console.log('Opening add review modal...');
        // Could trigger a review modal here
        break;
      case 'search-locations':
        console.log('Opening location search...');
        // Could trigger location search
        break;
      case 'plan-route':
        console.log('Opening route planner...');
        // Could trigger route planning
        break;
      case 'emergency-contacts':
        console.log('Opening emergency contacts...');
        // Could open emergency contacts
        break;
      case 'refresh':
        console.log('Refreshing dashboard data...');
        // Could refresh data
        break;
      default:
        console.log('Unknown action:', action);
    }
  };

  const handleShowMapFromDashboard = () => {
    console.log('Dashboard: Switching to Map view');
    if (onShowMap) {
      onShowMap();
    }
    if (onClose) {
      onClose(); // Close dashboard modal if it's a modal
    }
  };

  const stats = generateStats();
  const activities = generateActivities();

  if (!isOpen) return null;

  return (
    <SocialDashboard
      user={user}
      stats={stats}
      activities={activities}
      onAction={handleAction}
      onShowMap={handleShowMapFromDashboard}
      isLoading={false}
    />
  );
};

export default Dashboard;